export default "__VITE_ASSET__8ea033fe__"